<template>
  <div class="contentbox">
    <!--采购单模版选择-->
    <mt-popup
      v-model="popupVisible2"
      :modal="true"
      class="purchase_order_list_box"
      position="center">
      <slot>
        <ul class="purchase_order_list">
          <li v-for="itme in purchase_pdf_list" :key="itme.templates_id"
              @click="select_purchase_pdf(itme.templates_id)">
            <img :src="itme.templates_img" alt="">
            <div>{{itme.templates_title}}</div>
          </li>
        </ul>
      </slot>
    </mt-popup>
    <!--導入選項-->
    <mt-popup
      v-model="add_import_excel_box"
      :modal="true"
      class="add_import_excel_box"
      position="content">
      <slot>
        <div class="signature_box">
          <div>
            <input id="file" type="file">
          </div>
          <div class="paymentmethodbut">
            <mt-button @click="select_file" type="primary">確認導入</mt-button>
            <mt-button @click="add_import_excel_box = false" type="primary">取消導入</mt-button>
            <mt-button type="primary" @click="on_downloadTemplate">下載模板</mt-button>
          </div>
        </div>
      </slot>
    </mt-popup>
    <div class="conten">
      <ul :style="'width:'+ table_width" :class="state?'show_search':''">
        <li class="header_search" :class="state?'show_search':''">
          <div class="search_input_box">
            <div>
              <el-select v-model="$store.state.search_status"
                         @change="onsearch"
                         placeholder="狀態"
                         size="mini">
                <el-option
                  label="ALL"
                  :value="''">
                </el-option>
                <el-option
                  v-for="item in StateSetting_list"
                  :key="item.status_id"
                  :label="item.status_name"
                  :value="item.status_id">
                </el-option>
              </el-select>
            </div>
            <div>
              <el-select v-model="$store.state.search_type"
                         placeholder="數據類型"
                         @change="onsearch"
                         size="mini">
                <el-option
                  label="ALL"
                  :value="''">
                </el-option>
                <el-option
                  v-for="(item,index) in search_fields"
                  :key="index+'search_fields'"
                  :label="item.name"
                  :value="item.title_name">
                </el-option>
              </el-select>
            </div>
            <div class="date_box">
              <el-date-picker
                v-model="$store.state.search_date_h"
                type="date"
                size="mini"
                @change="onsearch"
                value-format="yyyy-MM-dd"
                placeholder="添加時間">
              </el-date-picker>
              <span class="connect">~</span>
              <el-date-picker
                v-model="$store.state.search_date_end"
                type="date"
                @change="onsearch"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="添加時間">
              </el-date-picker>
            </div>
            <div>
              <el-input size="mini"
                        @change="onsearch"
                        v-model="$store.state.key_word" placeholder="關鍵字"></el-input>
            </div>
            <div>
              <el-button size="mini" type="success" @click="add_import_excel_box = true">導入</el-button>
              <el-button size="mini" type="success" @click="Export">導出</el-button>
              <el-button size="mini" type="success" @click="onsearch">查找</el-button>
            </div>
          </div>
          <i class="el-icon-arrow-down" @click="showsearchbox"></i>
        </li>
        <!--表頭-->
        <li :class="state?'show_search':''" class="header_list">
          <div v-show="$store.state.Order_list_fields.dh.status === '1' && $store.state.Order_list_fields.dh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.dh.order">
            {{$store.state.Order_list_fields.dh.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.bzh.status === '1' && $store.state.Order_list_fields.bzh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.bzh.order">
            {{$store.state.Order_list_fields.bzh.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.bz.status === '1' && $store.state.Order_list_fields.bz.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.bz.order">
            {{$store.state.Order_list_fields.bz.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.kr.status === '1' && $store.state.Order_list_fields.kr.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.kr.order">
            {{$store.state.Order_list_fields.kr.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.tjsj.status === '1' && $store.state.Order_list_fields.tjsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.tjsj.order">
            {{$store.state.Order_list_fields.tjsj.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.yqsj.status === '1' && $store.state.Order_list_fields.yqsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.yqsj.order">
            {{$store.state.Order_list_fields.yqsj.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.htsrdwcsj.status === '1' && $store.state.Order_list_fields.htsrdwcsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.htsrdwcsj.order">
            {{$store.state.Order_list_fields.htsrdwcsj.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.zdzt.status === '1' && $store.state.Order_list_fields.zdzt.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.zdzt.order">
            {{$store.state.Order_list_fields.zdzt.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.czry.status === '1' && $store.state.Order_list_fields.czry.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.czry.order">
            {{$store.state.Order_list_fields.czry.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.kddh.status === '1' && $store.state.Order_list_fields.kddh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.kddh.order">
            {{$store.state.Order_list_fields.kddh.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.wcsj.status === '1' && $store.state.Order_list_fields.wcsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.wcsj.order">
            {{$store.state.Order_list_fields.wcsj.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.xgsj.status === '1' && $store.state.Order_list_fields.xgsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.xgsj.order">
            {{$store.state.Order_list_fields.xgsj.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.jgsmc.status === '1' && $store.state.Order_list_fields.jgsmc.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.jgsmc.order">
            {{$store.state.Order_list_fields.jgsmc.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.amount.status === '1' && $store.state.Order_list_fields.bzh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.amount.order"
               v-if="$route.query.page_style === 'management'">
            {{$store.state.Order_list_fields.amount.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.cz.status === '1' && $store.state.Order_list_fields.cz.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.cz.order">
            {{$store.state.Order_list_fields.cz.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.dc.status === '1' && $store.state.Order_list_fields.dc.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.dc.order">
            {{$store.state.Order_list_fields.dc.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.fj.status === '1' && $store.state.Order_list_fields.fj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.fj.order">
            {{$store.state.Order_list_fields.fj.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.ddlx.status === '1' && $store.state.Order_list_fields.ddlx.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.ddlx.order">
            {{$store.state.Order_list_fields.ddlx.name}}
          </div>
          <div v-show="$store.state.Order_list_fields.fwlx.status === '1' && $store.state.Order_list_fields.fwlx.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.fwlx.order">
            {{$store.state.Order_list_fields.fwlx.name}}</div>
          <div v-show="$store.state.Order_list_fields.ywydh.status === '1' && $store.state.Order_list_fields.ywydh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.ywydh.order">
            {{$store.state.Order_list_fields.ywydh.name}}
          </div>
          <!--業務員名稱-->
          <div v-show="$store.state.Order_list_fields.technicianname.status === '1' && $store.state.Order_list_fields.technicianname.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.technicianname.order">{{$store.state.Order_list_fields.technicianname.name}}</div>
          <!--lab 快遞單號-->
          <div v-show="$store.state.Order_list_fields.labkddh.status === '1' && $store.state.Order_list_fields.labkddh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.labkddh.order">{{$store.state.Order_list_fields.labkddh.name}}</div>
          <!--NAV customer no-->
          <div v-show="$store.state.Order_list_fields.navcustomerno.status === '1' && $store.state.Order_list_fields.navcustomerno.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.navcustomerno.order">
            {{$store.state.Order_list_fields.navcustomerno.name}}
          </div>
          <!--navsono-->
          <div v-show="$store.state.Order_list_fields.navsono.status === '1' && $store.state.Order_list_fields.navsono.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.navsono.order">
            {{$store.state.Order_list_fields.navsono.name}}
          </div>
          <!--Clinic order amount-->
          <div v-show="$store.state.Order_list_fields.clinicorderamount.status === '1' && $store.state.Order_list_fields.clinicorderamount.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.clinicorderamount.order">
            {{$store.state.Order_list_fields.clinicorderamount.name}}
          </div>
          <!--送貨日期-->
          <div v-show="$store.state.Order_list_fields.chrq.status === '1' && $store.state.Order_list_fields.chrq.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.chrq.order">
            {{$store.state.Order_list_fields.chrq.name}}
          </div>
          <!--Lab inv no-->
          <div v-show="$store.state.Order_list_fields.labinvno.status === '1' && $store.state.Order_list_fields.labinvno.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.labinvno.order">
            {{$store.state.Order_list_fields.labinvno.name}}
          </div>
          <!--合同簽署-->
          <div v-show="$store.state.Order_list_fields.htqs.status === '1' && $store.state.Order_list_fields.htqs.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.htqs.order">
            {{$store.state.Order_list_fields.htqs.name}}
          </div>
          <!--出庫單-->
          <div v-show="$store.state.Order_list_fields.ckd.status === '1' && $store.state.Order_list_fields.ckd.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.ckd.order">
            {{$store.state.Order_list_fields.ckd.name}}
          </div>
        </li>
        <!--報價單-->
        <li :key="index"
            v-for="(Orderdata,index) in OrderList"
            @click.self="edit(Orderdata.quotation_id)"
            :style="Orderdata.blue?'background: rgba(3,169,244,0.5)':''"
            :class="index%2===1?'':'white'">
          <!--單號-->
          <div v-if="$store.state.Order_list_fields.dh.status === '1' && $store.state.Order_list_fields.dh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.dh.order"
               @click="edit(Orderdata.quotation_id)">
            <span v-if="$store.state.list_class === 2">{{Orderdata.special_sort_number}}</span>
            <span v-else>{{Orderdata.quotation_code}}</span>
          </div>

          <!--備註號-->
          <div v-if="$store.state.Order_list_fields.bzh.status === '1' && $store.state.Order_list_fields.bzh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.bzh.order"
               @click="edit(Orderdata.quotation_id)">{{Orderdata.remarks_number}}</div>
          <!--<div v-if="$store.state.Order_list_fields.bzh.status === '1' && $store.state.Order_list_fields.bzh.order !== ''"-->
          <!--:style="'order:'+$store.state.Order_list_fields.bzh.order"-->
          <!--v-show="$store.state.list_class === 0"-->
          <!--@click="on_edit_order_state(Orderdata.quotation_id,true,'remarks_number_edit')">-->
          <!--<span class="modify_tag" v-show="!Orderdata.remarks_number_edit">{{Orderdata.remarks_number || '&nbsp;'}}</span>-->
          <!--<el-input size="mini"-->
          <!--placeholder="請輸入"-->
          <!--@keyup.enter.native="on_edit_order_state(Orderdata.quotation_id,false,'remarks_number_edit')"-->
          <!--v-show="Orderdata.remarks_number_edit"-->
          <!--v-model="Orderdata.remarks_number">-->
          <!--</el-input>-->
          <!--</div>-->

          <!--備註-->
          <div v-if="$store.state.Order_list_fields.bz.status === '1' && $store.state.Order_list_fields.bz.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.bz.order"
               v-show="$store.state.list_class !== 0"
               @click="edit(Orderdata.quotation_id)">{{Orderdata.remarks}}</div>
          <div v-if="$store.state.Order_list_fields.bz.status === '1' && $store.state.Order_list_fields.bz.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.bz.order"
               v-show="$store.state.list_class === 0"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'remarks_edit')">
            <span class="modify_tag" v-show="!Orderdata.remarks_edit">{{Orderdata.remarks || '&nbsp;'}}</span>
            <el-input size="mini"
                      placeholder="請輸入"
                      :ref="'remarks_edit'+Orderdata.quotation_id"
                      @blur="cancel_modification(Orderdata.quotation_id,false,'remarks_edit')"
                      @keyup.enter.native="on_edit_order_state(Orderdata.quotation_id,false,'remarks_edit')"
                      v-show="Orderdata.remarks_edit"
                      v-model="Orderdata.remarks">
            </el-input>
          </div>

          <!--客人名稱-->
          <div v-if="$store.state.Order_list_fields.kr.status === '1' && $store.state.Order_list_fields.kr.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.kr.order"
               class="break_all"
               @click="edit(Orderdata.quotation_id)">{{Orderdata.customer_liaisons}}</div>
          <!--<div v-if="$store.state.Order_list_fields.kr.status === '1'"-->
          <!--:style="'order:'+$store.state.Order_list_fields.kr.order"-->
          <!--v-show="$store.state.list_class === 0"-->
          <!--class="break_all"-->
          <!--@click="on_edit_order_state(Orderdata.quotation_id,true,'customer_liaisons_edit')">-->
          <!--<span class="modify_tag" v-show="!Orderdata.customer_liaisons_edit">{{Orderdata.customer_liaisons || '&nbsp;'}}</span>-->
          <!--<el-input size="mini"-->
          <!--placeholder="請輸入"-->
          <!--@keyup.enter.native="on_edit_order_state(Orderdata.quotation_id,false,'customer_liaisons_edit')"-->
          <!--v-show="Orderdata.customer_liaisons_edit"-->
          <!--v-model="Orderdata.customer_liaisons">-->
          <!--</el-input>-->
          <!--</div>-->

          <!--添加時間-->
          <div v-if="$store.state.Order_list_fields.tjsj.status === '1' && $store.state.Order_list_fields.tjsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.tjsj.order"
               @click="edit(Orderdata.quotation_id)">{{Orderdata.create_time}}</div>

          <!--要求時間-->
          <div v-if="$store.state.Order_list_fields.yqsj.status === '1' && $store.state.Order_list_fields.yqsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.yqsj.order"
               v-show="$store.state.list_class !== 0" @click="edit(Orderdata.quotation_id)">{{Orderdata.expected_installation_date}}</div>
          <div v-if="$store.state.Order_list_fields.yqsj.status === '1' && $store.state.Order_list_fields.yqsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.yqsj.order"
               v-show="$store.state.list_class === 0"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'expected_installation_date_edit')">
            <span class="modify_tag" v-show="!Orderdata.expected_installation_date_edit">{{Orderdata.expected_installation_date || '&nbsp;'}}</span>
            <el-date-picker
              @blur="on_edit_order_state(Orderdata.quotation_id,false,'expected_installation_date_edit')"
              v-show="Orderdata.expected_installation_date_edit"
              v-model="Orderdata.expected_installation_date"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              placeholder="請選擇日期">
            </el-date-picker>
          </div>

          <!--後台輸入的完成時間-->
          <div v-if="$store.state.Order_list_fields.htsrdwcsj.status === '1' && $store.state.Order_list_fields.htsrdwcsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.htsrdwcsj.order"
               v-show="$store.state.list_class !== 0" @click="edit(Orderdata.quotation_id)">{{Orderdata.backstage_completion_time}}</div>
          <div v-if="$store.state.Order_list_fields.htsrdwcsj.status === '1' && $store.state.Order_list_fields.htsrdwcsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.htsrdwcsj.order"
               v-show="$store.state.list_class === 0"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'backstage_completion_time_edit')">
            <span class="modify_tag" v-show="!Orderdata.backstage_completion_time_edit">{{Orderdata.backstage_completion_time || '&nbsp;'}}</span>
            <el-date-picker
              @blur="on_edit_order_state(Orderdata.quotation_id,false,'fast_odd_numbers_edit')"
              v-show="Orderdata.backstage_completion_time_edit"
              v-model="Orderdata.backstage_completion_time"
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              placeholder="請選擇日期">
            </el-date-picker>
          </div>

          <!--自定義狀態-->
          <div v-if="$store.state.Order_list_fields.zdzt.status === '1' && $store.state.Order_list_fields.zdzt.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.zdzt.order"
               v-show="$store.state.list_class !== 0" @click="edit(Orderdata.quotation_id)">
            <span v-if="!Orderdata.state_img">{{Orderdata.custom_status_name}}</span>
            <img v-else :src="Orderdata.state_img" alt="">
          </div>

          <div v-if="$store.state.Order_list_fields.zdzt.status === '1' && $store.state.Order_list_fields.zdzt.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.zdzt.order"
               v-show="$store.state.list_class === 0" @click="on_edit_order_state(Orderdata.quotation_id,true,'edit_order_state')">
            <span v-if="!Orderdata.state_img" class="modify_tag" v-show="!Orderdata.edit_order_state">{{Orderdata.custom_status_name}}</span>
            <img v-else v-show="!Orderdata.edit_order_state" :src="Orderdata.state_img" alt="">
            <el-select v-model="edit_order_state"
                       size="mini"
                       v-show="Orderdata.edit_order_state"
                       :ref="'edit_order_state'+Orderdata.quotation_id"
                       @blur="cancel_modification(Orderdata.quotation_id,false,'edit_order_state')"
                       @change="on_edit_order_state(Orderdata.quotation_id,false,'edit_order_state')">
              <el-option
                v-for="item in StateSetting_list"
                :key="item.status_id"
                :label="item.status_name"
                :disabled="!((item.signed_status === '0' && Orderdata.quotation_ifshow === '1') || (item.signed_status === '1' && Orderdata.quotation_ifshow === '2'))"
                :value="item.status_id">
              </el-option>
            </el-select>
          </div>

          <!--操作人員（用戶真實姓名）-->
          <div v-if="$store.state.Order_list_fields.czry.status === '1' && $store.state.Order_list_fields.czry.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.czry.order"
               class="break_all">{{Orderdata.dentist_name}}</div>
          <!--<div v-if="$store.state.Order_list_fields.czry.status === '1'"-->
          <!--:style="'order:'+$store.state.Order_list_fields.czry.order"-->
          <!--class="break_all"-->
          <!--v-show="$store.state.list_class === 0" @click="on_edit_order_state(Orderdata.quotation_id,true,'quotation_operator_edit')">-->
          <!--<span class="modify_tag" v-show="!Orderdata.quotation_operator_edit">{{Orderdata.quotation_operator}}</span>-->
          <!--<el-select v-model="Orderdata.quotation_operator"-->
          <!--size="mini"-->
          <!--v-show="Orderdata.quotation_operator_edit"-->
          <!--@change="on_edit_order_state(Orderdata.quotation_id,false,'quotation_operator_edit')">-->
          <!--<el-option-->
          <!--v-for="item in operator"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--</div>-->

          <!--hk 快遞單號-->
          <div v-if="$store.state.Order_list_fields.kddh.status === '1' && $store.state.Order_list_fields.kddh.order !== ''"
               v-show="$store.state.list_class !== 0"
               class="break_all"
               :style="'order:'+$store.state.Order_list_fields.kddh.order">{{Orderdata.fast_odd_numbers}}</div>
          <div v-if="$store.state.Order_list_fields.kddh.status === '1' && $store.state.Order_list_fields.kddh.order !== ''"
               class="break_all"
               :style="'order:'+$store.state.Order_list_fields.kddh.order"
               v-show="$store.state.list_class === 0"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'fast_odd_numbers_edit')">
            <span class="modify_tag" v-show="!Orderdata.fast_odd_numbers_edit">{{Orderdata.fast_odd_numbers || '&nbsp;'}}</span>
            <el-input size="mini"
                      placeholder="請輸入"
                      :ref="'fast_odd_numbers_edit'+Orderdata.quotation_id"
                      @blur="cancel_modification(Orderdata.quotation_id,false,'fast_odd_numbers_edit')"
                      @keyup.enter.native="on_edit_order_state(Orderdata.quotation_id,false,'fast_odd_numbers_edit')"
                      v-show="Orderdata.fast_odd_numbers_edit"
                      v-model="Orderdata.fast_odd_numbers">
            </el-input>
          </div>

          <!--完成時間-->
          <div v-if="$store.state.Order_list_fields.wcsj.status === '1' && $store.state.Order_list_fields.wcsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.wcsj.order">{{Orderdata.completion_time}}</div>
          <!--<div v-if="$store.state.Order_list_fields.wcsj.status === '1'"-->
          <!--:style="'order:'+$store.state.Order_list_fields.wcsj.order"-->
          <!--v-show="$store.state.list_class === 0"-->
          <!--@click="on_edit_order_state(Orderdata.quotation_id,true,'completion_time_edit')">-->
          <!--<span class="modify_tag" v-show="!Orderdata.completion_time_edit">{{Orderdata.completion_time || '&nbsp;'}}</span>-->
          <!--<el-date-picker-->
          <!--@blur="on_edit_order_state(Orderdata.quotation_id,false,'completion_time_edit')"-->
          <!--v-show="Orderdata.completion_time_edit"-->
          <!--v-model="Orderdata.completion_time"-->
          <!--type="date"-->
          <!--value-format="yyyy-MM-dd"-->
          <!--placeholder="請選擇日期">-->
          <!--</el-date-picker>-->
          <!--</div>-->

          <!--修改時間-->
          <div v-if="$store.state.Order_list_fields.xgsj.status === '1' && $store.state.Order_list_fields.xgsj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.xgsj.order">{{Orderdata.update_time}}</div>

          <!--供应商公司,技工所名稱-->
          <div v-if="$store.state.Order_list_fields.jgsmc.status === '1' && $store.state.Order_list_fields.jgsmc.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.jgsmc.order"
               v-show="$store.state.list_class !== 0">{{Orderdata.company_name}}</div>
          <div v-if="$store.state.Order_list_fields.jgsmc.status === '1' && $store.state.Order_list_fields.jgsmc.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.jgsmc.order"
               v-show="$store.state.list_class === 0" @click="on_edit_order_state(Orderdata.quotation_id,true,'customer_id_edit')">
            <span class="modify_tag" v-show="!Orderdata.customer_id_edit">{{Orderdata.company_name || '&nbsp;'}}</span>
            <el-select v-model="Orderdata.customer_id"
                       size="mini"
                       v-show="Orderdata.customer_id_edit"
                       :ref="'customer_id_edit'+Orderdata.quotation_id"
                       @blur="cancel_modification(Orderdata.quotation_id,false,'customer_id_edit')"
                       @change="on_edit_order_state(Orderdata.quotation_id,false,'customer_id_edit')">
              <el-option
                v-for="item in supplier_list"
                :key="item.company_id"
                :label="item.company_name"
                :value="item.company_id">
              </el-option>
            </el-select>
          </div>

          <!--金額-->
          <div v-if="$store.state.Order_list_fields.amount.status === '1' && $store.state.Order_list_fields.amount.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.amount.order"
               v-show="$route.query.page_style === 'management' && $store.state.list_class !== 0">{{Orderdata.amount}}</div>
          <div v-if="$store.state.Order_list_fields.amount.status === '1' && $store.state.Order_list_fields.amount.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.amount.order"
               v-show="$route.query.page_style === 'management' && $store.state.list_class === 0"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'amount_edit')">
            <span class="modify_tag" v-show="!Orderdata.amount_edit">{{Orderdata.amount || '&nbsp;'}}</span>
            <el-input size="mini"
                      placeholder="請輸入"
                      :ref="'amount_edit'+Orderdata.quotation_id"
                      @blur="cancel_modification(Orderdata.quotation_id,false,'amount_edit')"
                      @keyup.enter.native="on_edit_order_state(Orderdata.quotation_id,false,'amount_edit')"
                      v-show="Orderdata.amount_edit"
                      v-model="Orderdata.amount">
            </el-input>
          </div>

          <!--操作-->
          <div v-if="$store.state.Order_list_fields.cz.status === '1' && $store.state.Order_list_fields.cz.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.cz.order">
            <div style="display: none">
              <input :id="'file'+index" type="file" @change="upfile(Orderdata.quotation_id,index)">
            </div>
            <el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
                  <i @click="open_operation_magazine(Orderdata.quotation_id,index)"
                     class="el-icon-more more el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit"
                                  icon="el-icon-edit">編輯</el-dropdown-item>

                <el-dropdown-item command="upfile"
                                  icon="el-icon-upload"><label :for="'file'+index">附件</label></el-dropdown-item>

                <el-dropdown-item command="copy"
                                  icon="el-icon-document-copy">複製</el-dropdown-item>

                <el-dropdown-item command="sign"
                                  v-if="Orderdata.quotation_ifshow === '0' || Orderdata.quotation_ifshow === '1'"
                                  icon="el-icon-edit-outline">簽署</el-dropdown-item>

                <el-dropdown-item command="del"
                                  v-if="$store.state.list_class === 0 ||
                                  $store.state.list_class === 1 || $store.state.list_class === 2"
                                  icon="el-icon-delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!--導出-->
          <div  v-if="$store.state.Order_list_fields.dc.status === '1' && $store.state.Order_list_fields.dc.order !== ''"
                :style="'order:'+$store.state.Order_list_fields.dc.order"
                class="child_but_box">
            <el-dropdown class="purchase_order_box"
                         trigger="click"
                         @command="select_purchase_order"
                         v-if="Orderdata.purchase_ifshow === '2'">
                    <span class="el-dropdown-link">
                       <mt-button size="small" type="primary">採購單</mt-button>
                    </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(list,index) in Orderdata.purchase"
                                  :key="index"
                                  :command="[list.purchase_id,list.purchase_code]">
                  {{list.purchase_code}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown trigger="click" @command="select_pdf">
                    <span class="el-dropdown-link">
                       <mt-button size="small" type="primary">Export</mt-button>
                    </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(list,index) in pdf_list"
                                  :key="index"
                                  :command="[Orderdata.quotation_id,list.templates_id]">
                  {{list.templates_title}}
                </el-dropdown-item>
                <el-dropdown-item :command="[Orderdata.quotation_id,'','stickers']">
                  订单标签(90*31mm)
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!--附件-->
          <div v-if="$store.state.Order_list_fields.fj.status === '1' && $store.state.Order_list_fields.fj.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.fj.order">
            <!--<a v-if="itme_url" :href="itme_url" target="_blank" :key="i" v-for="(itme_url,i) in Orderdata.file_path">-->
            <!--<i style="margin: 0 5px" class="el-icon-paperclip"></i>-->
            <!--</a>-->
            <i
              v-if="itme_url" :key="i+'file_path'" v-for="(itme_url,i) in Orderdata.file_path"
              style="margin: 0 5px" @click="download2(itme_url)" class="el-icon-paperclip"></i>
          </div>

          <!--訂單類型-->
          <div v-if="$store.state.Order_list_fields.ddlx.status === '1' && $store.state.Order_list_fields.ddlx.order !== ''"
               v-show="$store.state.list_class !== 0"
               :style="'order:'+$store.state.Order_list_fields.ddlx.order">{{Orderdata.order_type_name}}</div>
          <div v-if="$store.state.Order_list_fields.ddlx.status === '1' && $store.state.Order_list_fields.ddlx.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.ddlx.order"
               v-show="$store.state.list_class === 0" @click="on_edit_order_state(Orderdata.quotation_id,true,'order_type_name_edit')">
            <span class="modify_tag" v-show="!Orderdata.order_type_name_edit">{{Orderdata.order_type_name || '&nbsp;'}}</span>
            <el-select v-model="Orderdata.order_type_id"
                       size="mini"
                       v-show="Orderdata.order_type_name_edit"
                       :ref="'order_type_name_edit'+Orderdata.quotation_id"
                       @blur="cancel_modification(Orderdata.quotation_id,false,'order_type_name_edit')"
                       @change="on_edit_order_state(Orderdata.quotation_id,false,'order_type_name_edit')">
              <el-option
                v-for="item in OrderType_list"
                :key="item.id"
                :label="item.order_type_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>

          <!--服務類型-->
          <div v-if="$store.state.Order_list_fields.fwlx.status === '1' && $store.state.Order_list_fields.fwlx.order !== ''"
               v-show="$store.state.list_class !== 0"
               :style="'order:'+$store.state.Order_list_fields.fwlx.order">{{Orderdata.service_category_name}}</div>
          <div v-if="$store.state.Order_list_fields.fwlx.status === '1' && $store.state.Order_list_fields.fwlx.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.fwlx.order"
               v-show="$store.state.list_class === 0" @click="on_edit_order_state(Orderdata.quotation_id,true,'service_category_name_edit')">
            <span class="modify_tag" v-show="!Orderdata.service_category_name_edit">{{Orderdata.service_category_name || '&nbsp;'}}</span>
            <el-select v-model="Orderdata.service_category_id"
                       size="mini"
                       v-show="Orderdata.service_category_name_edit"
                       :ref="'service_category_name_edit'+Orderdata.quotation_id"
                       @blur="cancel_modification(Orderdata.quotation_id,false,'service_category_name_edit')"
                       @change="on_edit_order_state(Orderdata.quotation_id,false,'service_category_name_edit')">
              <el-option
                v-for="item in ServiceCategory_list"
                :key="item.id"
                :label="item.service_category_name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>

          <!--業務員代號-->
          <div v-if="$store.state.Order_list_fields.ywydh.status === '1' && $store.state.Order_list_fields.ywydh.order !== ''"
               v-show="$store.state.list_class !== 0"
               class="break_all"
               :style="'order:'+$store.state.Order_list_fields.ywydh.order">
            {{Orderdata.salesman_number_str}}
          </div>
          <div v-if="$store.state.Order_list_fields.ywydh.status === '1' && $store.state.Order_list_fields.ywydh.order !== ''"
               class="break_all"
               :style="'order:'+$store.state.Order_list_fields.ywydh.order"
               v-show="$store.state.list_class === 0"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'salesman_number_edit')">
            <span  class="modify_tag" v-show="!Orderdata.salesman_number_edit">{{Orderdata.salesman_number_str}}</span>
            <el-select v-model="Orderdata.salesman_number"
                       size="mini"
                       v-show="Orderdata.salesman_number_edit"
                       :ref="'salesman_number_edit'+Orderdata.quotation_id"
                       @blur="cancel_modification(Orderdata.quotation_id,false,'salesman_number_edit')"
                       @change="on_edit_order_state(Orderdata.quotation_id,false,'salesman_number_edit')">
              <el-option
                v-for="item in operator"
                :key="item.id"
                :label="item.name+'('+item.number+')'"
                :value="item.id">
              </el-option>
            </el-select>
          </div>

          <!--技術員名稱-->
          <div v-if="$store.state.Order_list_fields.technicianname.status === '1' && $store.state.Order_list_fields.technicianname.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.technicianname.order"
               v-show="$store.state.list_class !== 2">{{Orderdata.technician_name || '&nbsp;'}}</div>
          <div v-if="$store.state.Order_list_fields.technicianname.status === '1' && $store.state.Order_list_fields.technicianname.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.technicianname.order"
               v-show="$store.state.list_class === 2"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'technician_name_edit')">
            <span class="modify_tag" v-show="!Orderdata.technician_name_edit">{{Orderdata.technician_name || '&nbsp;'}}</span>
            <el-input size="mini"
                      placeholder="請輸入"
                      :ref="'technician_name_edit'+Orderdata.quotation_id"
                      @blur="cancel_modification(Orderdata.quotation_id,false,'technician_name_edit')"
                      @keyup.enter.native="on_edit_order_state(Orderdata.quotation_id,false,'technician_name_edit')"
                      v-show="Orderdata.technician_name_edit"
                      v-model="Orderdata.technician_name">
            </el-input>
          </div>

          <!--lab 快遞單號-->
          <div v-if="$store.state.Order_list_fields.labkddh.status === '1' && $store.state.Order_list_fields.labkddh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.labkddh.order"
               v-show="$store.state.list_class === 1">{{Orderdata.courier_odd_numbers || '&nbsp;'}}</div>
          <div v-if="$store.state.Order_list_fields.labkddh.status === '1' && $store.state.Order_list_fields.labkddh.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.labkddh.order"
               v-show="$store.state.list_class !== 1"
               @click="on_edit_order_state(Orderdata.quotation_id,true,'courier_odd_numbers_edit')">
            <span class="modify_tag" v-show="!Orderdata.courier_odd_numbers_edit">{{Orderdata.courier_odd_numbers || '&nbsp;'}}</span>
            <el-input size="mini"
                      placeholder="請輸入"
                      :ref="'courier_odd_numbers_edit'+Orderdata.quotation_id"
                      @blur="cancel_modification(Orderdata.quotation_id,false,'courier_odd_numbers_edit')"
                      @keyup.enter.native="on_edit_order_state(Orderdata.quotation_id,false,'courier_odd_numbers_edit')"
                      v-show="Orderdata.courier_odd_numbers_edit"
                      v-model="Orderdata.courier_odd_numbers">
            </el-input>
          </div>
          <!--NAV customer no-->
          <div v-if="$store.state.Order_list_fields.navcustomerno.status === '1' && $store.state.Order_list_fields.navcustomerno.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.navcustomerno.order">
            {{Orderdata.user_remarks_number || '&nbsp;'}}
          </div>
          <!--navsono-->
          <div v-if="$store.state.Order_list_fields.navsono.status === '1' && $store.state.Order_list_fields.navsono.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.navsono.order">
            {{Orderdata.our_remarks || '&nbsp;'}}
          </div>
          <!--Clinic order amount-->
          <div v-if="$store.state.Order_list_fields.clinicorderamount.status === '1' && $store.state.Order_list_fields.clinicorderamount.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.clinicorderamount.order">
            {{Orderdata.custom_amount || '&nbsp;'}}
          </div>
          <!--送貨日期-->
          <div v-if="$store.state.Order_list_fields.chrq.status === '1' && $store.state.Order_list_fields.chrq.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.chrq.order">
            {{Orderdata.shipping_date}}
          </div>
          <!--Lab inv no-->
          <div v-if="$store.state.Order_list_fields.labinvno.status === '1' && $store.state.Order_list_fields.labinvno.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.labinvno.order">
            {{Orderdata.your_remarks|| '&nbsp;'}}
          </div>
          <!--合同簽署-->
          <div v-if="$store.state.Order_list_fields.htqs.status === '1' && $store.state.Order_list_fields.htqs.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.htqs.order">
            <mt-button size="small" @click="signature(Orderdata.quotation_id)" type="primary">Confirm</mt-button>
          </div>
          <!--出庫單單-->
          <div v-if="$store.state.Order_list_fields.ckd.status === '1' && $store.state.Order_list_fields.ckd.order !== ''"
               :style="'order:'+$store.state.Order_list_fields.ckd.order">
            <mt-button size="small" @click="export_outbound_order_pdf(Orderdata.quotation_id)" type="primary">PDF</mt-button>
          </div>
        </li>
        <!--庫單-->

      </ul>
      <div v-if="$store.state.list_class === 1 ||
       ($store.state.list_class === 0 && (this.$route.query.page_style === undefined || this.$route.query.page_style === 'undefined')) ||
       ($store.state.list_class === 2)"
           class="add_order_but"
           @click="reopenNewOrder()">
        <i class="el-icon-circle-plus-outline"></i>
      </div>
      <div class="bottom_but">
        <el-button type="success" @click="printit">
          PRINT
          <!--<a href="javascript:window.print()" target="_self">PRINT</a>-->
        </el-button>
        <div class="page_but_box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            background
            :page-size="20"
            layout="total, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
          <!--<el-button v-show="$store.state.list_class === 1" @click="switch_list(2)" type="success">技工所</el-button>-->
          <!--<el-button v-show="$store.state.list_class === 2" @click="switch_list(1)" type="success">原列表</el-button>-->
          <!--<el-button v-show="$store.state.list_class === 1" @click="switch_list(0)" type="success">員工</el-button>-->
        </div>
      </div>
    </div>
    <div v-show="showmode" @click="onhiddenmode" class="pdfimgmode">
      <iframe :src="pdfimgurl"></iframe>
    </div>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    commitOrderList,
    commitOrderDel,
    commitOrderEdit,
    exportPdf,
    delPdf,
    uploadFile,
    getusersInfg,
    getSelectionTemplates,
    purchase_order_exportPdf,
    delOrderFile,
    paymentInterface,
    orderCopy,
    orderSigned,
    getServiceUser,
    editSaveUsers,
    getStatusSettingData,
    orderListEditSave,
    getSupplierData,
    commitInstallationCharge,
    getOrderTypeData,
    getServiceCategoryData,
    ajaxRequest,
    contractSigning,
    orderdetails_downloadTemplate,
    orderdetails_import_excel,
    export_pdf,
  } from '../../assets/js/api'
  import ScrollPosition from '../../assets/js/scroll-position'
  import {traditionalized, simplized} from '../../assets/js/language'

  export default {
    name: "orderlist",
    data() {
      return {
        currentPage: Number(this.$route.query.currentPage) || 1,//當前頁數
        total: 0,//數據總數
        OrderList: '',
        searchvalue: '',
        state: false,
        showmode: false,
        discount: 0,
        popupVisible2: false,
        order_index: '',
        order_id: '',
        pdf_list: [],
        purchase_pdf_list: [],
        purchase_parameter: [],
        payment_options: [], //付款方式
        screen_paymentmethod_state: false, //是否筛选支付方式
        screen_paymentmethod: [], //选中需要筛选的支付方式,可选多个
        screen_deposit_state: false, //是否筛选订金百分比范围
        screen_deposit: [10, 80], //需要筛选的订金百分比范围
        screen_balance: false, //筛选还有余款的订单
        screen_date_range_state: false, //是否对日期范围进行筛选
        screen_date_range_start: '', //筛选时的开始日期
        screen_date_range_end: '', //筛选时的结束日期
        screen_operator_state: '', //是否筛选操作人
        screen_operator: '', //选择筛选的操作人
        input_screen_deposit: false,
        show_screen_box: false,
        operator: [],//操作人
        list_type: 1,
        pdfimgurl: '',
        edit_state: false, //編輯狀態
        code_list: [], //區號
        edit_order_state: '', //POS状态设定
        StateSetting_list: [], //POS状态设定列表
        supplier_list: [], //供应商数据
        OrderType_list:[], //订单类型数据
        ServiceCategory_list:[], //服务类别数据
        type_list:[], //订单类型数据 + 服务类别数据
        Latest_order_ID:'', //最新訂單id
        setInterval_time:'', //定時器
        search_fields:[], //搜索字段列表
        table_width:0, // 表格寬度
        add_import_excel_box:false, // 表格寬度
        page_style:this.$route.query.page_style //当前订单类型
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {

      this.$store.commit('set_list_class',Number(JSON.parse(localStorage.getItem('userdata')).users_role)) //用户角色
      //根據當前用戶身份顯示字段
      if (this.$store.state.list_class === 0){
        this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_yg)
      }
      else if (this.$store.state.list_class === 1){
        this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom)
      }
      else if (this.$store.state.list_class === 2){
        this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_gys)
      }

      // 處理搜索字段
      setTimeout(()=>{
        let table_number = 5
        for (let itme in this.$store.state.Order_list_fields){
          if (this.$store.state.Order_list_fields[itme].status === '1' && this.$store.state.Order_list_fields[itme].order !== ''){
            if (itme === 'dh'){
              this.$store.state.Order_list_fields[itme].title_name = 'quotation_code'
            }
            if (itme === 'bzh'){
              this.$store.state.Order_list_fields[itme].title_name = 'remarks_number'
            }
            if (itme === 'bz'){
              this.$store.state.Order_list_fields[itme].title_name = 'remarks'
            }
            if (itme === 'kr'){
              this.$store.state.Order_list_fields[itme].title_name = 'customer_liaisons'
            }
            if (itme === 'tjsj'){
              this.$store.state.Order_list_fields[itme].title_name = 'create_time'
            }
            if (itme === 'yqsj'){
              this.$store.state.Order_list_fields[itme].title_name = 'expected_installation_date'
            }
            if (itme === 'htsrdwcsj'){
              this.$store.state.Order_list_fields[itme].title_name = 'backstage_completion_time'
            }
            if (itme === 'zdzt'){
              this.$store.state.Order_list_fields[itme].title_name = 'custom_status_name'
            }
            if (itme === 'czry'){
              this.$store.state.Order_list_fields[itme].title_name = 'user_real_name'
            }
            if (itme === 'kddh'){
              this.$store.state.Order_list_fields[itme].title_name = 'courier_odd_numbers'
            }
            if (itme === 'wcsj'){
              this.$store.state.Order_list_fields[itme].title_name = 'completion_time'
            }
            if (itme === 'xgsj'){
              this.$store.state.Order_list_fields[itme].title_name = 'update_time'
            }
            if (itme === 'ywydh'){
              this.$store.state.Order_list_fields[itme].title_name = 'salesman_number_str'
            }
            if (itme === 'jgsmc'){
              this.$store.state.Order_list_fields[itme].title_name = 'company_name'
            }
            if (itme === 'ddlx'){
              this.$store.state.Order_list_fields[itme].title_name = 'order_type_name'
            }
            if (itme === 'fwlx'){
              this.$store.state.Order_list_fields[itme].title_name = 'service_category_name'
            }
            if (itme === 'navcustomerno'){
              this.$store.state.Order_list_fields[itme].title_name = 'user_remarks_number'
            }
            if (itme === 'technicianname'){
              this.$store.state.Order_list_fields[itme].title_name = 'technician_name'
            }
            if (itme === 'labkddh'){
              this.$store.state.Order_list_fields[itme].title_name = 'courier_odd_numbers'
            }
            // 收集列表字段
            if (this.$store.state.Order_list_fields[itme].title_name){
              table_number += 1
              this.search_fields.push(this.$store.state.Order_list_fields[itme])
            }
          }
        }
        this.search_fields.sort((a,b)=>{return a.order - b.order})
        if ((table_number * 120) < window.screen.width){
          this.table_width = '100%'
        }
        else {
          this.table_width = (table_number * 120) + 'px'
        }
      },1000)

      // 获取订单类型数据
      getOrderTypeData().then(data=>{
        if (data.status){
          this.OrderType_list = data.data
          this.OrderType_list.map(itme=>{
            itme.name = itme.order_type_name
            itme.value = [itme.id,'OrderType']
          })
          this.type_list = this.type_list.concat(this.OrderType_list)
        }
      })

      // 获取服务类别数据
      getServiceCategoryData().then(data=>{
        if (data.status){
          this.ServiceCategory_list = data.data
          this.ServiceCategory_list.map(itme=>{
            itme.name = itme.service_category_name
            itme.value = [itme.id,'ServiceType']
          })
          this.type_list = this.type_list.concat(this.ServiceCategory_list)
        }
      })

      //獲取銷售單的状态设定
      getStatusSettingData().then(data => {
        if (data.status) {
          this.StateSetting_list = data.data
        }
      })

      // 获取供应商数据
      getSupplierData(2).then(data => {
        if (data.status && data.data){
          this.supplier_list = data.data
        }
      })

      // 获取模板列表
      getSelectionTemplates('quotationsheet_temp_id').then(data => {
        if (data.status) {
          this.pdf_list = data.data.tempData
        }
      })

      // 获取采购单模板列表
      getSelectionTemplates('purchase_temp_id').then(data => {
        if (data.status) {
          this.purchase_pdf_list = data.data.tempData
        }
      })

      // 支付方式
      paymentInterface().then((data) => {
        if (data.status) {
          this.payment_options = data.userinfo || []
        }
      })

      if (this.$route.query.key) {
        this.searchvalue = this.$route.query.key
        this.state = true
      }

      this.onsearch()

      // 編寫定時器，每隔5分鐘刷新一次訂單
      this.Check_new_orders()
      if (this.$store.state.list_class !== 1){
        this.setInterval_time = setInterval(()=>{
          this.Check_new_orders()
        },300000)
      }

      if (this.$route.query.source) {
        setTimeout(() => {
          ScrollPosition.get.call(this);
        }, 500)
      }

    },
    methods: {
      // 選擇文件
      select_file(){
        let formData = new window.FormData()
        formData.append('file', document.getElementById('file').files[0])
        if (document.getElementById('file').files[0] === undefined){
          this.$message({
            type: 'warning',
            message: '請選擇需要導入的文件'
          });
          return
        }
        orderdetails_import_excel(formData).then(data=>{
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.data,
            }).then(() => {
            });
          }
          else {
            this.$alert(data.data, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
          this.add_import_excel_box = false
          if (data.status){
            this.onsearch()
          }
        })
      },
      on_downloadTemplate(){
        window.open(orderdetails_downloadTemplate(),'_blank')
      },
      signature(order_id){
        contractSigning(order_id,'contract').then(data=>{
          if (data.status){
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: data.message,
              }).then(() => {
              });
            }
            else {
              this.$alert(data.message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
          else {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: data.message,
              }).then(() => {
              });
            }
            else {
              this.$alert(data.message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
        })
      },
      export_outbound_order_pdf(order_id){
        export_pdf('GET','','blob',order_id).then(data=>{
          let downloadElement = document.createElement('a');
          // 创建下载的链接
          let href = window.URL.createObjectURL(data.data);
          // 文件名
          let file_name = 'pdf_file'
          // console.log(file_name)
          downloadElement.href = href;
          if (window.navigator.msSaveBlob) {
            try {
              window.navigator.msSaveBlob(data.data, file_name)
            } catch (e) {
              console.log(e);
            }
          }
          else {
            // 下载后文件名
            downloadElement.download = file_name;
            document.body.appendChild(downloadElement);
            // 点击下载
            downloadElement.click();
            // 下载完成移除元素
            document.body.removeChild(downloadElement);
            // 释放掉blob对象
            window.URL.revokeObjectURL(href);
          }
        })
      },
      download2(url){
        ajaxRequest('GET',url,'blob').then(data=>{
          // console.log(data)
          let downloadElement = document.createElement('a');
          // 创建下载的链接
          let href = window.URL.createObjectURL(data.data);
          // 文件名
          let file_name = url.split('/')[url.split('/').length-1]
          // console.log(file_name)
          downloadElement.href = href;
          if (window.navigator.msSaveBlob) {
            try {
              window.navigator.msSaveBlob(data.data, file_name)
            } catch (e) {
              console.log(e);
            }
          }
          else {
            // 下载后文件名
            downloadElement.download = file_name;
            document.body.appendChild(downloadElement);
            // 点击下载
            downloadElement.click();
            // 下载完成移除元素
            document.body.removeChild(downloadElement);
            // 释放掉blob对象
            window.URL.revokeObjectURL(href);
          }
        })
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.onsearch()
        // console.log(`当前页: ${val}`);
      },
      printit(){
        try{
          print.portrait   =  false    ;//横向打印
        }catch(e){
          alert("不支持此方法");
        }
        window.print();
      },
      timestampToTime(timestamp) {
        var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y + M + D + h + m + s;
      }
      ,
      on_edit_order_state(quotation_id, state, field_name) {
        this.OrderList.map(itme => {
          if (itme.quotation_id === quotation_id) {
            this.$set(itme, field_name, state)
            if (!state) {
              let p_data = {"order_id": quotation_id,}
              //修改備註號
              if (field_name === 'remarks_number_edit') {
                p_data.remarks_number = itme.remarks_number
              }
              //修改備註
              else if (field_name === 'remarks_edit') {
                p_data.remarks = itme.remarks
              }
              //修改客人名稱
              else if (field_name === 'customer_liaisons_edit') {
                p_data.customer_receiver = itme.customer_liaisons
              }
              //修改要求時間
              else if (field_name === 'expected_installation_date_edit') {
                p_data.expected_installation_date = itme.expected_installation_date
              }
              //後台輸入的完成時間
              else if (field_name === 'backstage_completion_time_edit') {
                p_data.backstage_completion_time = itme.backstage_completion_time
              }
              //修改自定義狀態
              else if (field_name === 'edit_order_state') {
                this.StateSetting_list.map(list => {
                  if (this.edit_order_state === list.status_id) {
                    p_data.custom_status_id = list.status_id
                    p_data.custom_status_name = list.status_name
                  }
                })
              }
              //修改操作员
              else if (field_name === 'quotation_operator_edit') {
                p_data.quotation_operator = itme.quotation_operator
              }
              //修改快递单号
              else if (field_name === 'fast_odd_numbers_edit') {
                p_data.fast_odd_numbers = itme.fast_odd_numbers
              }
              //修改完成時間
              // else if (field_name === 'completion_time_edit') {
              //   p_data.completion_time = itme.completion_time
              // }
              //修改供應商
              else if (field_name === 'customer_id_edit') {
                p_data.customer_id = itme.customer_id
                // 同時修改對應狀態
                // p_data.custom_status_id = this.StateSetting_list[2].status_id
                // p_data.custom_status_name = this.StateSetting_list[2].status_name
              }
              //修改金額
              else if (field_name === 'amount_edit') {
                p_data.amount = itme.amount
              }
              //修改業務員代號
              else if (field_name === 'salesman_number_edit') {
                p_data.salesman_number = itme.salesman_number
              }
              //修改訂單類型
              else if (field_name === 'order_type_name_edit') {
                p_data.order_type_id = itme.order_type_id
              }
              //修改服務類型
              else if (field_name === 'service_category_name_edit') {
                p_data.service_category_id = itme.service_category_id
              }
              // 技术员名称
              else if (field_name === 'technician_name_edit') {
                p_data.technician_name = itme.technician_name
                // 同時修改對應狀態
                // p_data.custom_status_id = this.StateSetting_list[3].status_id
                // p_data.custom_status_name = this.StateSetting_list[3].status_name
              }
              // lab 快遞單號
              else if (field_name === 'courier_odd_numbers_edit') {
                p_data.courier_odd_numbers = itme.courier_odd_numbers
                // 同時修改對應狀態
                // p_data.custom_status_id = this.StateSetting_list[4].status_id
                // p_data.custom_status_name = this.StateSetting_list[4].status_name
                // 同時修改完成時間
                // p_data.completion_time = this.getNowTime(true)
              }
              //修改編輯時間为当前时间
              // p_data.update_time = itme.completion_time

              orderListEditSave(p_data).then(data => {
                this.$message({
                  type: 'success',
                  message: data.message
                });
                if (data.status) {
                  this.onsearch()
                }
              })
            }
            else {
              setTimeout(()=>{
                if (!this.$refs[field_name+quotation_id]){
                  return
                }
                if (this.$refs[field_name+quotation_id][0].$refs.reference){
                  this.$refs[field_name+quotation_id][0].$refs.reference.$refs.input.click()
                }
                else if(this.$refs[field_name+quotation_id][0].$refs.input){
                  this.$refs[field_name+quotation_id][0].$refs.input.focus()
                }
              })
            }
          }
        })
      },
      cancel_modification(quotation_id, state, field_name){
        this.OrderList.map(itme => {
          if (itme.quotation_id === quotation_id) {
            this.$set(itme, field_name, state)
          }
        })
      }
      ,
      on_editSaveUsers() {
        editSaveUsers(this.usersInfo).then(data => {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.message,
            }).then(() => {
              this.edit_state = false
            });
          }
          else {
            this.$alert(data.message, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.edit_state = false
              }
            });
          }
        })
      }
      ,
      //切換訂單類型
      switch_list_type(list_type) {
        this.list_type = list_type
        this.onsearch()
      }
      ,
      //切換列表
      switch_list(list_class) {
        this.$store.commit('set_list_class', list_class) //用户身份
        this.onsearch()
        //根據當前用戶身份顯示字段
        if (this.$store.state.list_class === 0){
          this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_yg)
        }
        else if (this.$store.state.list_class === 1){
          this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom)
        }
        else if (this.$store.state.list_class === 2){
          this.$store.commit('set_Order_list_fields',this.$store.state.page_state.order_custom_gys)
        }
        if (this.$store.state.list_class === 2) {
          this.$message({
            type: 'success',
            message: '已切換至供應商列表!'
          });
        }
        else if (this.$store.state.list_class === 1) {
          this.$message({
            type: 'success',
            message: '已切換回原列表!'
          });
        }
        else {
          this.$message({
            type: 'success',
            message: '已切換至員工列表!'
          });
        }
      }
      ,
      // 修改订金范围输入框时同步滑块
      on_input_screen_deposit() {
        this.screen_deposit = [Number(this.screen_deposit[0]), Number(this.screen_deposit[1])]
        this.input_screen_deposit = !this.input_screen_deposit
      }
      ,
      handleCommand(command) {
        if (command === 'edit') {
          this.edit()
        }
        else if (command === 'del') {
          this.del()
        }
        else if (command === 'copy') {
          orderCopy(this.order_id).then(data => {
            if (data.status) {
              this.onsearch()
              if (this.$store.state.client) {
                MessageBox({
                  title: '提示',
                  message: '複製成功',
                }).then(() => {
                });
              }
              else {
                this.$alert('複製成功', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
            }
            else {
              if (this.$store.state.client) {
                MessageBox({
                  title: '提示',
                  message: '複製失敗',
                }).then(() => {
                });
              }
              else {
                this.$alert('複製失敗', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
            }
          })
        }
        else if (command === 'sign') {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '您确定簽署订单吗？',
              showCancelButton: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消"
            }).then((confirm) => {
              if (confirm === 'confirm')
                contractSigning(this.order_id,'price_sheet').then(data => {
                  if (data.status) {
                    this.onsearch()
                    if (this.$store.state.client) {
                      MessageBox({
                        title: '提示',
                        message: '簽署成功',
                      }).then(() => {
                      });
                    }
                    else {
                      this.$alert('簽署成功', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                      });
                    }
                  }
                  else {
                    if (this.$store.state.client) {
                      MessageBox({
                        title: '提示',
                        message: '簽署失敗',
                      }).then(() => {
                      });
                    }
                    else {
                      this.$alert('簽署失敗', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                        }
                      });
                    }
                  }
                })
            });
          }
          else {
            this.$confirm('您确定簽署订单吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              distinguishCancelAndClose: true,
              type: 'warning'
            }).then(() => {
              contractSigning(this.order_id,'price_sheet').then(data => {
                if (data.status) {
                  this.onsearch()
                  if (this.$store.state.client) {
                    MessageBox({
                      title: '提示',
                      message: '簽署成功',
                    }).then(() => {
                    });
                  }
                  else {
                    this.$alert('簽署成功', '提示', {
                      confirmButtonText: '确定',
                      callback: action => {
                      }
                    });
                  }
                }
                else {
                  if (this.$store.state.client) {
                    MessageBox({
                      title: '提示',
                      message: '簽署失敗',
                    }).then(() => {
                    });
                  }
                  else {
                    this.$alert('簽署失敗', '提示', {
                      confirmButtonText: '确定',
                      callback: action => {
                      }
                    });
                  }
                }
              })
            }).catch((c) => {
            });
          }

        }

      }
      ,
      select_pdf(command) {
        this.ongetpdf(command[0], command[1],command[2])
      }
      ,
      select_purchase_order(command) {
        this.popupVisible2 = true
        this.purchase_parameter = command
      }
      ,
      select_purchase_pdf(templates_id) {
        purchase_order_exportPdf({
          purchase_id: this.purchase_parameter[0],
          purchase_code: this.purchase_parameter[1],
          templates_id: templates_id,
        }).then(data => {
          console.log(data)
          if (!navigator.userAgent.match(/(phone|UC|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
            window.open(data, '_blank')
          }
          else {
            window.open(data, '_self')
          }
        }).catch((e) => {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: '請求出錯',
            })
          }
          else {
            this.$alert('請求出錯', '提示', {
              confirmButtonText: '确定',
            });
          }
        })
      }
      ,
      // 跳转到购物车
      toCart() {
        this.$router.push({path: '/shoppingcart'});
      }
      ,
      // 打开操作弹框
      open_operation_magazine(id, index) {
        this.order_id = id
        this.order_index = index
      }
      ,
      reopenNewOrder() {
        sessionStorage.removeItem('LocalShoppingCart');
        sessionStorage.removeItem('order_id');
        sessionStorage.removeItem('quotation_code');
        this.$store.commit('res_state')
        this.$router.push({path: '/index'});
      }
      ,
      inorderlist() {
        this.$store.commit('set_inorderilstroutername', 'shoppingcart?id=' + this.$route.query.id)
        this.$router.push({path: '/orderlist'});
      }
      ,
      // 上传附件
      upfile(id, index) {
        id = id || this.order_id
        index = index || this.order_index
        let formData = new window.FormData()
        formData.append('file', document.getElementById('file' + index).files[0])
        formData.append('id', id)
        let fileName = this.$store.state.loginuserdata.username + '_' + this.getNowTime()
        formData.append('fileName', fileName)
        uploadFile(formData).then((data) => {
          if (data.status) {
            this.OrderList.map(itme => {
              if (itme.quotation_id === id) {
                itme.file_path = data.file_path
              }
            })
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: data.message,
              }).then(() => {
              });
            }
            else {
              this.$alert(data.message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
          else {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: '上传失败',
              }).then(() => {
              });
            }
            else {
              this.$alert('上传失败', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
        })
      }
      ,
      // 获得当前时间 2019-02-02 14:06:08
      getNowTime(istime) {
        // 加0
        function add_10(num) {
          if (num < 10) {
            num = '0' + num
          }
          return num;
        }

        let myDate = new Date();
        let nowTimes = myDate.getFullYear() + '-' + add_10(myDate.getMonth() + 1) + '-' + myDate.getDate() + '_' + add_10(myDate.getHours()) + ':' + add_10(myDate.getMinutes()) + ':' + add_10(myDate.getSeconds());
        let nowTimes2 = myDate.getFullYear() + '-' + add_10(myDate.getMonth() + 1) + '-' + myDate.getDate();
        if (istime){
          return nowTimes2;
        }
        else {
          return nowTimes;
        }
      }
      ,
      time_stamp(time){
        function add_10(num) {
          if (num < 10) {
            num = '0' + num
          }
          return num;
        }
        let myDate = new Date(parseInt(time+'000'));
        if (time){
          return (myDate.getFullYear() + '-' + add_10(myDate.getMonth() + 1) + '-' + myDate.getDate());
        }
        else {
          return ''
        }
      },
      // 删除附件
      deleteflie(order_id, filename) {
        let name = filename.split('/')[filename.split('/').length - 1]
        if (this.$store.state.client) {
          MessageBox({
            title: '提示',
            message: '確定删除附件' + name,
            showCancelButton: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          }).then((confirm) => {
            if (confirm === 'confirm')
              delOrderFile(order_id, filename).then((data) => {
                if (data.status) {
                  this.onsearch()
                }
                if (this.$store.state.client) {
                  MessageBox({
                    title: '提示',
                    message: data.message,
                  }).then(res => {
                  })
                }
                else {
                  this.$alert(data.message, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                  });
                }
              })
          });
        }
        else {
          this.$confirm('確定删除附件' + name, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            delOrderFile(order_id, filename).then((data) => {
              if (data.status) {
                this.onsearch()
              }
              if (this.$store.state.client) {
                MessageBox({
                  title: '提示',
                  message: data.message,
                }).then(res => {
                })
              }
              else {
                this.$alert(data.message, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
            })
          }).catch((c) => {
          });
        }
      }
      ,
      ongetpdf(id, pdfid,templates_type) {
        id = id || this.order_id
        commitOrderEdit(id).then(data => {
          // 回写数据
          // console.log(data)
          data.templates_id = pdfid
          data.templates_type = templates_type
          exportPdf(data).then((data) => {
            this.showmode = true
            this.pdfimgurl = data
            if (!navigator.userAgent.match(/(phone|UC|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
              // window.open(this.pdfimgurl, '_blank')
            }
            else {
              // window.open(this.pdfimgurl, '_self')
            }
          }).catch((e) => {
            if (this.$store.state.client) {
              MessageBox({
                title: '提示',
                message: '請求出錯',
              })
            }
            else {
              this.$alert('請求出錯', '提示', {
                confirmButtonText: '确定',
              });
            }
          })
        })
      }
      ,
      onhiddenmode() {
        this.showmode = false
        this.pdfimgurl = ''
        // this.pdfimgurl
        // delPdf(this.pdfimgurl).then((data) => {
        //   console.log(data)
        // })
      }
      ,
      showsearchbox() {
        if (this.state) {
          this.state = false
        }
        else {
          this.state = true
        }
      }
      ,
      Export(){
        let p_data = {}
        p_data.userid = localStorage.getItem('logindata')
        p_data.custom_status = this.$store.state.search_status
        p_data.create_date_start = this.$store.state.search_date_h
        p_data.create_date_end = this.$store.state.search_date_end
        p_data.key_word = this.$store.state.key_word
        p_data.page = this.currentPage
        p_data.title_name = this.$store.state.search_type

        if (this.$route.query.page_style === undefined || this.$route.query.page_style === 'undefined'){
          p_data.page_classify = 'tesco'
        }
        ajaxRequest('GET','','blob',p_data).then(data=>{
          // console.log(data)
          let downloadElement = document.createElement('a');
          // 创建下载的链接
          let href = window.URL.createObjectURL(data.data);
          // 文件名
          let file_name = 'export_file'
          // console.log(file_name)
          downloadElement.href = href;
          if (window.navigator.msSaveBlob) {
            try {
              window.navigator.msSaveBlob(data.data, file_name)
            } catch (e) {
              console.log(e);
            }
          }
          else {
            // 下载后文件名
            downloadElement.download = file_name;
            document.body.appendChild(downloadElement);
            // 点击下载
            downloadElement.click();
            // 下载完成移除元素
            document.body.removeChild(downloadElement);
            // 释放掉blob对象
            window.URL.revokeObjectURL(href);
          }
        })
      },
      onsearch() {
        let p_data = {}
        p_data.userid = localStorage.getItem('logindata')
        p_data.custom_status = this.$store.state.search_status
        p_data.create_date_start = this.$store.state.search_date_h
        p_data.create_date_end = this.$store.state.search_date_end
        p_data.key_word = this.$store.state.key_word
        p_data.page = this.currentPage
        p_data.title_name = this.$store.state.search_type

        //本地订单
        this.page_style = this.$route.query.page_style
        if (this.page_style === undefined || this.page_style === 'undefined'){
          p_data.page_classify = 'tesco'
        }
        // console.log(p_data)
        commitOrderList(p_data).then(data => {
          this.total = Number(data.total_count)
          console.log(data,'???')
          this.OrderList = data.data
          if (this.OrderList){
            // expected_installation_date
            // 获取服务人员.操作人
            getServiceUser().then(data => {
              if (data.status) {
                this.operator = data.data
                this.OrderList.map(itme=>{
                  if (itme.expected_installation_date && this.$store.state.list_class === 2){
                    itme.expected_installation_date = this.DecreaseDayToDate(itme.expected_installation_date,3)
                  }
                  if (this.$store.state.list_class === 0 && itme.user_operation_status !== '1'){
                    itme.blue = true
                  }
                  if (this.$store.state.list_class === 1 && itme.guest_operation_status !== '1'){
                    itme.blue = true
                  }
                  if (this.$store.state.list_class === 2 && itme.supplier_operation_status !== '1'){
                    itme.blue = true
                  }
                  this.operator.map(list=>{
                    if (itme.salesman_id === list.id){
                      this.$set(itme,'salesman_number_str',list.name+'('+list.number+')')
                    }
                  })
                })
              }
            })

          }
          // operator
        })
      },
      // 檢查是否有新單
      Check_new_orders(){
        let p_data = {}
        p_data.userid = localStorage.getItem('logindata')
        p_data.custom_status = ''
        p_data.create_date_start = ''
        p_data.create_date_end = ''
        p_data.key_word = ''
        p_data.page = 1
        p_data.page_classify = 'tesco'
        // console.log(p_data)
        commitOrderList(p_data).then(data => {
          if (this.Latest_order_ID && this.Latest_order_ID !== data.data[0].quotation_id){
            this.$alert('您有新的訂單，請注意查看', '提示', {
              confirmButtonText: '确定',
            });
            if (this.currentPage === 1){
              this.OrderList = data.data
              if (this.OrderList){
                // expected_installation_date
                // 获取服务人员.操作人
                getServiceUser().then(data => {
                  if (data.status) {
                    this.operator = data.data
                    this.OrderList.map(itme=>{
                      if (itme.expected_installation_date && this.$store.state.list_class === 2){
                        itme.expected_installation_date = this.DecreaseDayToDate(itme.expected_installation_date,3)
                      }
                      if (this.$store.state.list_class === 0 && itme.user_operation_status !== '1'){
                        itme.blue = true
                      }
                      if (this.$store.state.list_class === 1 && itme.guest_operation_status !== '1'){
                        itme.blue = true
                      }
                      if (this.$store.state.list_class === 2 && itme.supplier_operation_status !== '1'){
                        itme.blue = true
                      }
                      this.operator.map(list=>{
                        if (itme.salesman_id === list.id){
                          this.$set(itme,'salesman_number_str',list.name+'('+list.number+')')
                        }
                      })
                    })
                  }
                })

              }
            }
          }
          this.Latest_order_ID = data.data[0].quotation_id
        })
      }
      ,
      DecreaseDayToDate(Time, days) {
        let a = new Date(Time)
        a = a.valueOf()
        a = a - days * 24 * 60 * 60 * 1000
        let date = new Date(a)
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d
      },
      returnrouter() {
        this.$router.push({path: '/' + this.$store.state.inorderilstroutername});
      }
      ,
      del(id, index) {
        id = id || this.order_id
        index = index || this.order_index
        if (this.$store.state.client) {
          MessageBox({
            title: '提示',
            message: '您确定删除订单吗？',
            showCancelButton: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          }).then((confirm) => {
            if (confirm === 'confirm')
              commitOrderDel(id).then(data => {
                if (data.status) {
                  this.OrderList.splice(index, 1)
                }
                else {
                  MessageBox({
                    title: '提示',
                    message: '删除失败',
                    showCancelButton: false
                  }).then((v) => {
                    this.onsearch()
                  });
                }
              })
          });
        }
        else {
          this.$confirm('您确定删除订单吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            distinguishCancelAndClose: true,
            type: 'warning'
          }).then(() => {
            commitOrderDel(id).then(data => {
              if (data.status) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.OrderList.splice(index, 1)
              }
              else {
                this.$message({
                  type: 'error',
                  message: data.message
                });
                this.onsearch()
              }
            })
          }).catch((c) => {
          });
        }
      }
      ,
      edit(id) {
        id = id || this.order_id
        this.getcommitOrderEdit(id)
      }
      ,
      getcommitOrderEdit(id) {
        commitOrderEdit(id).then(data => {
          // 回写数据
          this.$store.commit('setname', data.customer_liaisons) //用户名称
          this.$store.commit('setphone', data.customer_tel) //用户手机号码
          this.$store.commit('setemail', data.customer_email) //用户邮箱

          this.$store.commit('set_system', data.system) //安裝位置備註
          this.$store.commit('set_collecting', data.collecting) //否收牙模 1是 0否
          this.$store.commit('set_gender', data.gender) //性別 1 男 2女
          this.$store.commit('set_age', data.age) //年齡
          this.$store.commit('set_operator', data.operator) //操作人
          this.$store.commit('set_user_real_name', data.user_real_name) //用户真实姓名
          this.$store.commit('set_dentist_name', data.dentist_name) //另外的用户真实姓名
          this.$store.commit('set_dentist_name_id', data.dentist_name_id) //另外的用户id
          this.$store.commit('set_customer_id', data.customer_id) //客戶公司ID
          this.$store.commit('set_fast_odd_numbers', data.fast_odd_numbers) //快遞單號
          this.$store.commit('set_backstage_completion_time', data.backstage_completion_time) //快遞單號
          this.$store.commit('set_shipping_date', data.shipping_date) //出貨日期

          // 新增字段
          this.$store.commit('set_our_remarks', data.our_remarks) //我方备注
          this.$store.commit('set_salesperson_id', data.salesperson_id) //销售员ID(用戶)
          this.$store.commit('set_custom_amount', data.custom_amount) //金额
          this.$store.commit('set_charge_amount', data.charge_amount) //加工费or运输费
          this.$store.commit('set_your_remarks', data.your_remarks) //供方备注
          this.$store.commit('set_reference_number', data.reference_number) //Lab编号 lab reference no
          this.$store.commit('set_service_grade', data.service_grade) //服务等级
          this.$store.commit('set_dental_model_quantity', data.dental_model_quantity) //no of 牙模
          this.$store.commit('set_technician_name', data.technician_name) //Technician name
          this.$store.commit('set_courier_odd_numbers', data.courier_odd_numbers) //Lab快递单号
          this.$store.commit('set_user_remarks_number', data.user_remarks_number) //NAV customer no

          this.$store.commit('set_quotation_code', data.quotation_code) //订单编号
          this.$store.commit('set_remarks', data.remarks) //订单备注
          this.$store.commit('set_orderdiscount_id', data.discount_id) //订单折扣id标识
          this.$store.commit('set_delivery_method', data.delivery_method) //送貨方式id
          let date = data.expected_installation_date
          if (date && this.$store.state.list_class === 2){
            date = this.DecreaseDayToDate(data.expected_installation_date,3)
          }
          this.$store.commit('setDeliverytime', { //日期方式和安装日期和时间
            time: data.select_time_interval,
            time_type: 1,
            datevalue: date,
          })
          let obj = {
            address: data.customer_address,
            latLngData: data.latLngData
          }
          this.$store.commit('setReceivingaddress', obj) //订单地址
          this.$store.commit('setPaymentmethod', id) //订单id
          let all
          if (Number(data.discount_product) === 0) {
            all = Number.parseFloat(data.discount) + Number.parseFloat(data.quotation_total_price)
          }
          else {
            if (Number.parseFloat(data.discount_product) < Number.parseFloat(data.discount)) {
              all = Number.parseFloat(data.discount_product) + Number.parseFloat(data.quotation_total_price)
            }
            else {
              all = Number.parseFloat(data.discount) + Number.parseFloat(data.quotation_total_price)
            }
          }
          let discount = Math.floor((data.discount / all) * 100).toFixed(2)
          // 获取员工折扣
          getusersInfg().then((usersInfg_data) => {
            let lowest_discount = usersInfg_data.data.lowest_discount
            if (lowest_discount) {
              lowest_discount.map(itme => {
                if (itme.id === data.discount_id) {
                  discount = itme.value
                  this.$store.commit('set_orderdiscount', Number.parseFloat(discount)) //订单折扣
                }
              })
            }
          })


          this.$store.commit('set_quotation_ifshow', data.quotation_ifshow) //订单状态
          this.$store.commit('set_signature_status', data.electronic_signature_status) //订单状态
          this.$store.commit('set_InstallMode', data.install_value_id - 1) //安装方式
          this.$store.commit('set_shippingcost', data.shippingcost || 0) //运输费
          this.$store.commit('set_freight', data.shippingcost_id.split(',') || '') //运输费id
          this.$store.commit('set_enclosure', data.file_path) //订单附件

          this.$store.commit('set_deposit_amount', Number.parseFloat(data.deposit_amount)) //定金金额
          this.$store.commit('set_payment_record', data.payment_record) //订单定金支付列表

          this.$store.commit('set_create_time', this.time_stamp(data.create_time)) //訂單日期

          commitInstallationCharge().then((installationfeedata) => {
            if (installationfeedata.status) {
              if (installationfeedata.data) {
                let installationfeed = []
                installationfeedata.data.map(itme => {
                  data.installation_charge_number = data.installation_charge_number || ''
                  data.installation_charge_id = data.installation_charge_id || ''
                  let a = data.installation_charge_number.split(',')
                  if (data.installation_charge_id && data.installation_charge_id.split(',')){
                    data.installation_charge_id.split(',').map((list, index) => {
                      if (itme.i_id === list) {
                        installationfeed.push({
                          i_price: Number.parseFloat(itme.i_price),
                          i_id: itme.i_id,
                          num: a[index] ? a[index] : 1
                        })
                      }
                      // 第二层
                      if (itme.sonData) {
                        itme.sonData.map(itme2 => {
                          if (itme2.i_id === list) {
                            installationfeed.push({
                              i_price: Number.parseFloat(itme2.i_price),
                              i_id: itme2.i_id,
                              num: a[index] ? a[index] : 1
                            })
                          }
                          // 第三层
                          if (itme2.sonData) {
                            itme2.sonData.map(itme3 => {
                              if (itme3.i_id === list) {
                                installationfeed.push({
                                  i_price: Number.parseFloat(itme3.i_price),
                                  i_id: itme3.i_id,
                                  num: a[index] ? a[index] : 1
                                })
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
                this.$store.commit('setinstallationfee', installationfeed || []) //安装费
              }
            }
          })

          let urgent;

          data.urgent === '0' ? urgent = false : urgent = true
          this.$store.commit('set_urgent', urgent) //是否加急

          // 处理产品数据
          if (data.productData && data.productData.length){
            data.productData.map((itme) => {
              itme.expend_price = itme.productprice
              itme.sum = itme.totalquantity
              itme.result = itme.product_formula_result_value
              itme.product_parts_proid = itme.product_parts_num
              itme.product_id = itme.productid
              // canvas使用圖片跨域問題
              if (window.location.protocol !== 'https:' && itme.canvas_img_data){
                let arr = itme.canvas_img_data.split(':')
                arr[0] = 'http:'
                itme.canvas_img_data = arr.join('')
              }
            })
          }

          sessionStorage.setItem('LocalShoppingCart', JSON.stringify(data.productData || []))
          sessionStorage.setItem('order_id', id);
          sessionStorage.setItem('quotation_code', data.quotation_code);
          this.$router.push({path: '/orderdetails?id=' + id + '&currentPage=' + this.currentPage + '&page_style=' + this.$route.query.page_style});
        })
      }
      ,
    },
    destroyed() {//离开该页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll)
      clearInterval(this.setInterval_time) //清除定時器
    },
    watch: {
      '$route':'onsearch'
    }
    ,
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  html, body, #app {
    height: 100%;
  }

  body /deep/ .el-date-picker {
    z-index: 2020 !important;
  }

  .contentbox {
    background-color: #f2f2f2;
    width: 100%;
    .conten {
      overflow: auto;
      ul {
        width: 100%;
        height: ~"calc(100vh - 165px)";
        background-color: #f2f2f2;
        padding-bottom: 1px;
        /*min-height: 96vh;*/
        /*margin-top: 52px;*/
        padding-top: 80px;
        transition: all 0.5s;
        &.show_search{
          padding-top: 130px;
        }
        li {
          width: 96%;
          padding: 10px 2%;
          display: flex;
          /*flex-direction: column;*/
          align-items: center;
          justify-content: space-around;
          /*justify-content: flex-start;*/
          margin: 5px 0;
          &.white {
            background: white;
          }
          &.header_list {
            /*position: fixed;*/
            background-color: #57c5f7;
            padding: 20px 2%;
            margin: 0;
            z-index: 9;
            top: 80px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            &.show_search{
              top: 112px;
            }
            > div {
              font-size: 15px;
              font-weight: bold;
            }
          }
          &.header_search {
            width: 100%;
            position: fixed;
            flex-direction: column;
            justify-items: center;
            background-color: #327594;
            margin: 0;
            padding: 10px 0;
            z-index: 9;
            top: 52px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            height: 10px;
            .search_input_box{
              display: none;
              width: 90%;
              cursor: auto;
              >div{
                margin: 0 20px;
                width: 20%;
                display: flex;
                align-items: center;
                &.date_box{
                  width: 25%;
                }
                .connect{
                  margin: 0 5px;
                }
              }
            }
            &.show_search{
              height: 60px;
              .search_input_box{
                display: flex;
                align-items: center;
                justify-content: center;
              }
              >i{
                transform: rotate(180deg);
              }
            }
            > i {
              transition: all 0.5s;
              font-size: 20px;
              font-weight: bold;
              cursor: pointer;
            }
          }
          > div {
            width: 120px;
            /*min-width: 5%;*/
            text-align: center;
            cursor: pointer;
            word-wrap: break-word;
            img{
              max-width: 90%;
            }
            &.break_all{
              word-break:break-all;
            }
            .modify_tag{
              border-bottom: 1px #000 dotted;
              display: inline-block;
              padding: 5px;
              min-width: 50%;
            }
            >div{
              width: 100%;
            }
          }
        }
      }
      ul.equipment_management {
        margin-top: 70px;
      }
      .personal_settings {
        padding: 20px;
        background: #fff;
        .title {
          text-align: center;
          font-size: 26px;
          margin: 30px auto;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          width: 80%;
          @media (min-width: @screen-xs-max) {
            width: 20%;
          }
          i {
            font-size: 20px;
            cursor: pointer;
          }

        }
        .form_max_box {
          .form_itme {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 20px auto;
            width: 80%;
            @media (min-width: @screen-xs-max) {
              width: 20%;
            }
            &.but_box {
              justify-content: space-around;
              margin-top: 50px;
            }
            .el-input {
              width: 50%;
            }
          }
        }
      }
      .bottom_but {
        position: fixed;
        width: 96%;
        padding: 0 2%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        bottom: 30px;
        .page_but_box{
          display: flex;
          align-items: center;
          >div{
            margin-right: 20px;
          }
        }
        a{
          color: #fff;
        }
      }
      .add_order_but {
        position: fixed;
        bottom: 80px;
        right: 2%;
        cursor: pointer;
        i {
          color: #67C23A;
          font-size: 48px;
        }
      }
    }
    .pdfimgmode {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      z-index: 999999;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all;
      background-color: rgba(0, 0, 0, 0.5);
      iframe {
        width: 70%;
        height: 90%;
      }
    }
    .signature_box {
      background: #fff;
      height: 25vh;
      width: 80vw;
      padding-top: 10%;
      text-align: center;
      @media (min-width: @screen-xs-max) {
        width: 30vw;
      }
      ul {
        padding-bottom: 20px;
        li {
          margin-top: 20px;
        }
      }
      .paymentmethodbut {
        display: flex;
        justify-items: center;
        justify-content: center;
        margin-top: 20px;
        .mint-button {
          /*margin-right: 20px;*/
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
    .add_import_excel_box{
      .signature_box {
        padding: 50px;
        height: auto;
        div{
          div{
            margin-bottom: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist_child/childorderdetails.vue